export { default as Homepage } from './lib/homepage'
export type { VehiclesData } from './lib/types/vehicles-data'
export { getVehiclesData } from './lib/data/get-vehicles-data'

export type {
  HomeStoryContent,
  PersonalisedSection,
} from './lib/types/home-story-content'

export { getServerSideProps } from './lib/get-server-side-props'

export { Filters } from './lib/components/hero-v2/filters'
